import { actionTypes, mutationTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.OCORRENCIA.BUSCAR_OCORRENCIAS]({ commit }, { paginacao, filtro }) {
		const { data } = await api.ocorrencia.buscarOcorrencias(paginacao, filtro)
		commit(mutationTypes.OCORRENCIA.SET_INFORMACOES_ITENS_OCORRENCIA, data)
		return data
	},
	async [actionTypes.OCORRENCIA.INSERIR_OCORRENCIA](context, objParam) {
		const { data } = await api.ocorrencia.inserirOcorrencia(objParam)
		return data
	},

	async [actionTypes.OCORRENCIA.ENVIAR_RESPOSTA_OCORRENCIA](context, objParam) {
		await api.ocorrencia.enviarRespostaOcorrencia(objParam)
	},

	async [actionTypes.OCORRENCIA.VISUALIZAR_OCORRENCIA](context, payload) {
		const { data } = await api.ocorrencia.visualizarOcorrencia(payload)
		return data
	},

	async [actionTypes.OCORRENCIA.EDITAR_RESPOSTA](context, payload) {
		const { data } = await api.ocorrencia.editarRespostaOcorrencia(payload)
		return data
	},
	async [actionTypes.OCORRENCIA.EXCLUIR_OCORRENCIA](context, objParam) {
		const { data } = await api.ocorrencia.excluirRespostaOcorrencia(objParam)
		return data
	},
	async [actionTypes.OCORRENCIA.EDITAR_OCORRENCIA](context, objParam) {
		await api.ocorrencia.editarOcorrencia(objParam)
	},

	async [actionTypes.OCORRENCIA.ATUALIZAR_OCORRENCIA]({ state, dispatch, commit }, payload) {
		const { data } = await api.ocorrencia.atualizarOcorrencia(payload)
		dispatch(actionTypes.OCORRENCIA.BUSCAR_OCORRENCIAS, {
			paginacao: state.paginacao,
			filtro: {
				idEntidade: state.informacoesOcorrencia.idEntidade,
				tipoEntidade: state.informacoesOcorrencia.tipoEntidade,
			},
		})

		commit(mutationTypes.OCORRENCIA.SET_KEY_LISTAR_OCORRENCIAS)
		return data
	},
}
